/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AbstractStep } from './abstractStep';
import { MarketingScenarioProcess } from './marketingScenarioProcess';
import { TransactionalScenarioProcess } from './transactionalScenarioProcess';

export interface CreateScenarioDTO { 
    name?: string;
    affiliateCode?: string;
    description?: string;
    owner?: string;
    icon?: string;
    type?: CreateScenarioDTO.TypeEnum;
    process?: MarketingScenarioProcess | TransactionalScenarioProcess;
    steps?: Array<AbstractStep>;
    affectedPartners?: Array<string>;
    allowMultipleEnrollments?: boolean;
    recordSaleCost?: boolean;
}
export namespace CreateScenarioDTO {
    export type TypeEnum = 'MARKETING' | 'TRANSACTIONAL';
    export const TypeEnum = {
        MARKETING: 'MARKETING' as TypeEnum,
        TRANSACTIONAL: 'TRANSACTIONAL' as TypeEnum
    };
}